import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteUiProvider } from "@/context/SiteUiContext";
import { LangProvider } from "@/context/LangContext";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import ChatWidget from "@/components/site/ChatWidget";
import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import MapPage from "@/pages/MapPage";
import Tours from "@/pages/Tours";
import Cars from "@/pages/Cars";
import Guides from "@/pages/Guides";
import Planner from "@/pages/Planner";
import AuthPage from "@/pages/AuthPage";
import MyBookings from "@/pages/MyBookings";
import BookingStatus from "@/pages/BookingStatus";
import ReviewInvite from "@/pages/ReviewInvite";
import OpenTrip from "@/pages/OpenTrip";
import Partner from "@/pages/Partner";
import PartnerProfile from "@/pages/PartnerProfile";
import PartnerJob from "@/pages/PartnerJob";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <SiteUiProvider>
          <BrowserRouter>
            <ScrollTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/destinations" element={<Destinations />} />
                <Route path="/destinations/:slug" element={<DestinationDetail />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/tours" element={<Tours />} />
                <Route path="/cars" element={<Cars />} />
                <Route path="/guides" element={<Guides />} />
                <Route path="/planner" element={<Planner />} />
                <Route path="/login" element={<AuthPage mode="login" />} />
                <Route path="/register" element={<AuthPage mode="register" />} />
                <Route path="/bookings" element={<MyBookings />} />
                <Route path="/booking-status" element={<BookingStatus />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/review/:token" element={<ReviewInvite />} />
                <Route path="/open-trip" element={<OpenTrip />} />
                <Route path="/mitra" element={<Partner />} />
                <Route path="/mitra/:slug" element={<PartnerProfile />} />
                <Route path="/mitra/tugas/:token" element={<PartnerJob />} />
                <Route path="/join-us" element={<Partner />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppFab />
            <ChatWidget />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
          </SiteUiProvider>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
